<header class="bciti-dialog__header">
    <div class="bciti-dialog__title">
        {{ 'pages.user-cards.user-search-results.title' | translate }}
    </div>
    <button class="bciti-dialog__close-button" (click)="closeDialog()">
        <span  class="icon icon-close"></span>
    </button>
</header>

<div class="bciti-dialog__content">
    <div class="results-wrapper">
        <mat-selection-list class="results" (selectionChange)="onSelectChange($event)" [multiple]="false">
            <mat-list-option class="result" *ngFor="let result of results" [value]="result">
                <div class="result__inner">
                    <app-avatar [picture]="result.picture"></app-avatar>
                    <div>
                        <strong>
                            {{ result.firstName }} {{ result.lastName }}
                        </strong>
                    </div>
                    <div>
                        <span *ngIf="result.sex">
                            {{ 'pages.user-cards.family.common.gender.' + result.sex.toUpperCase() | translate }}
                        </span>
                        <span *ngIf="!result.sex">&nbsp;</span>
                    </div>
                    <div>
                        <span *ngIf="result.birthDate">
                            {{ result.birthDate | date: 'd MMM yyyy' }}
                        </span>
                        <span *ngIf="!result.birthDate">&nbsp;</span>
                    </div>
                    <div [matTooltip]="result.email">{{ result.email || '&nbsp;' }}</div>
                    <div [matTooltip]="result.cardCode">{{ result.cardCode || '&nbsp;' }}</div>
                </div>
            </mat-list-option>
        </mat-selection-list>
    </div>
    <div class="notice">
        {{ 'pages.user-cards.user-search-results.notice' | translate }}
    </div>
</div>

<footer class="bciti-dialog__footer bciti-dialog__footer--right">
    <button class="bciti-button bciti-button--lightblue-inversed" (click)="onBack()">
        {{ 'pages.user-cards.common.button.back' | translate }}
    </button>
    <button 
        class="bciti-button" 
        [ngClass]="submitLoading || !selectedResult ? 'bciti-button--disabled' : 'bciti-button--blue'" 
        [disabled]="submitLoading || !selectedResult"
        (click)="onSubmit()"
    >
        <span *ngIf="!submitLoading">{{ 'pages.user-cards.common.button.confirm' | translate }}</span>
        <mat-spinner diameter="20" *ngIf="submitLoading"></mat-spinner>
    </button>
</footer>